import { defineModel, serializable } from '../model'

class TechnicArticles {
    @serializable()
    items: ApiModel<'TechnicArticle'>[]

    @serializable()
    limit: number

    @serializable()
    offset: number

    @serializable()
    totalItems: number
}

export default defineModel(TechnicArticles)
